import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=283f301e&scoped=true"
import script from "./Pricing.vue?vue&type=script&lang=ts"
export * from "./Pricing.vue?vue&type=script&lang=ts"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=283f301e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f301e",
  null
  
)

export default component.exports